<template>
  <div>
    <span
      v-if="showIcon"
      class="cursor-pointer text-main-primary"
      @click="showInformationGuide"
    ><InfoRoundedSmall /></span>
    <ModalComponent
      name="HeatandSteamGuideModal"
      class="overflow-y-auto"
      :width="700"
      height="auto"
      :adaptive="true"
      :scrollable="true"
      :click-to-close="true"
    >
      <div class="w-full px-8 py-4">
        <div class="flex w-full justify-between gap-2">
          <h1 class="mb-2 font-semibold text-main-primary">
            Guidance
          </h1>
          <button
            class="flex h-8 w-8 items-center justify-center rounded-md bg-gray-100 text-[#808080] outline-none"
            @click="hideInformationGuide"
          >
            <TimesSmall />
          </button>
        </div>
      </div>
      <hr class="mb-3">
      <div class="mb-6 px-8">
        <div class="mb-2 text-gray-500">
          <p class="text-xs">
            Welcome to the VERIDIS Platform's Heat and Steam Data Entry. We're
            thrilled to have you join us in our mission to monitor and manage,
            let's get started!
          </p>
        </div>
        <hr class="my-3">
        <div v-if="stepCount">
          <div class="my-3 text-gray-500">
            <h1 class="mb-2 font-semibold text-main-primary">
              What is Scope 2- Heat and Steam?
            </h1>
            <p class="text-xs">
              Scope 2 emissions related to heat and steam are typically
              associated with the indirect emissions generated from the
              production and consumption of heat and steam in an organization's
              operations. These emissions are categorized under Scope 2 because
              they result from the consumption of purchased energy sources (in
              this case, heat and steam) and are considered indirect emissions.
            </p>
          </div>

          <div class="my-3 text-gray-500">
            <h1 class="mb-2 font-semibold text-main-primary">
              How it works?
            </h1>
            <p class="text-xs">
              Similar to Purchased Electricity, companies are required to report
              emissions from the purchase and use of heat and steam energy
              products separately under Scope 2: according to a location-based
              and market-based method.
            </p>
          </div>

          <div class="my-3 text-gray-500">
            <ul class="list-disc px-4 text-xs">
              <li class="my-2">
                <h1 class="mb-2 font-semibold text-main-primary">
                  Location-Based Method:
                </h1>
                <ul>
                  <li>
                    Calculate emissions based on the local energy grid, and this
                    grid's carbon intensity is used to define the emissions
                    factor for the calculation.
                  </li>
                </ul>
              </li>
              <li class="my-2">
                <h1 class="mb-2 font-semibold text-main-primary">
                  Market-Based Method
                  <span
                    class="mb-2 mr-2 w-fit rounded border border-yellow-300 bg-yellow-100 px-2.5 py-0.5 text-xs font-medium text-yellow-800"
                  >
                    Coming Soon</span>
                </h1>
                <ul>
                  <li>
                    Calculate emissions by considering the characteristics of
                    specific heat and steam purchase agreements or others. Use
                    this method if you have specific sources you've committed
                    to, and you'll likely see a different emissions value
                    compared to the Location-Based Method on the asset page.
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
        <div v-else>
          <div class="my-3 text-gray-500">
            <h1 class="mb-2 font-semibold text-main-primary">
              Step-by-Step Guide
            </h1>
            <p class="text-xs">
              You are now in the Heat and Steam data upload page, you may close
              the guidance pop-out to start uploading data manually in the table
              cells or via excel file upload. Whenever you’re ready!
            </p>
          </div>
          <div class="my-3 text-gray-500">
            <h1 class="mb-2 font-semibold text-main-primary underline">
              For manual entry
            </h1>
            <p class="text-xs">
              You are now in the Heat and Steam data upload page, you may close
              the guidance pop-out to start uploading data manually in the table
              cells or via excel file upload. Whenever you’re ready!
            </p>
          </div>

          <div class="my-3 text-gray-500">
            <ul class="list-none text-xs">
              <li class="my-2">
                <h1 class="flex gap-2 text-[#1A242A]">
                  <span
                    class="flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full bg-main-primary text-white"
                  >1</span>
                  <span class="py-1 font-bold">Date</span>
                </h1>
                <ul>
                  <li class="px-8">
                    Insert the date when the emissions were measured or detected
                    <ul class="list-disc px-4 text-xs">
                      <li>Date format (dd/mm/yyyy)</li>
                    </ul>
                  </li>
                </ul>
              </li>
              <li class="my-2">
                <h1 class="flex gap-2 text-[#1A242A]">
                  <span
                    class="flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full bg-main-primary text-white"
                  >2</span>
                  <span class="py-1 font-bold">Item Discription</span>
                </h1>
                <ul>
                  <li class="px-8">
                    To help us assist you better, please label your
                    Heat/Steam/Cooling-related data as example below in
                    parenthesis:
                    <ul class="list-disc px-4 text-xs">
                      <li>Heat Usage</li>
                      <li>Heat and Steam Bill (Grid)</li>
                    </ul>
                  </li>
                </ul>
              </li>
              <li class="my-2">
                <h1 class="flex gap-2 text-[#1A242A]">
                  <span
                    class="flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full bg-main-primary text-white"
                  >3</span>
                  <span class="py-1 font-bold">Amount</span>
                </h1>
                <ul>
                  <li class="px-8">
                    Fill in the energy amount.
                  </li>
                </ul>
              </li>
              <li class="my-2">
                <h1 class="flex gap-2 text-[#1A242A]">
                  <span
                    class="flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full bg-main-primary text-white"
                  >4</span>
                  <span class="py-1 font-bold">Input Unit</span>
                </h1>
                <ul>
                  <li class="px-8">
                    Select the unit of measurement.
                  </li>
                </ul>
              </li>
              <li class="my-2">
                <h1 class="flex gap-2 text-[#1A242A]">
                  <span
                    class="flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full bg-main-primary text-white"
                  >5</span>
                  <span class="py-1 font-bold">Asset</span>
                </h1>
                <ul>
                  <li class="px-8">
                    Choose the asset from which emissions originate.
                  </li>
                </ul>
              </li>
              <li class="my-2">
                <h1 class="flex gap-2 text-[#1A242A]">
                  <span
                    class="flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full bg-main-primary text-white"
                  >6</span>
                  <span class="py-1 font-bold">Emission Factors</span>
                </h1>
                <ul>
                  <li class="px-8">
                    <ul class="list-disc px-4 text-xs">
                      <li>
                        Selection of EF: VERIDIS auto-matches your input data
                        with a specific emission factor. If needed, you can
                        select an alternative from the top 5 best-matched
                        factors.
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>
            </ul>
          </div>

          <div class="my-3 text-gray-500">
            <h1 class="mb-2 font-semibold text-main-primary underline">
              For Excel file upload
            </h1>
            <p class="text-xs">
              Follow the instructions when you click "Upload Excel."
            </p>
          </div>
        </div>
      </div>

      <div class="flex justify-between gap-4 border-t bg-gray-100 px-8 py-3">
        <div class="flex justify-start gap-1 pt-4">
          <span
            :class="`h-1.5 w-1.5 ${stepCount ? 'bg-main-primary' : 'bg-gray-300'}  rounded-full`"
          />
          <span
            :class="`h-1.5 w-1.5 ${stepCount ? 'bg-gray-300' : 'bg-main-primary'} rounded-full`"
          />
        </div>
        <PrimaryButton
          v-if="stepCount"
          @click="stepCount = 0"
        >
          Next
        </PrimaryButton>
        <PrimaryButton
          v-else
          @click="hideInformationGuide"
        >
          Continue
        </PrimaryButton>
      </div>
    </ModalComponent>
  </div>
</template>

<script>
export default {
  name: 'HeatandSteamGuideModal',

  props: {
    showModal: {
      type: Boolean,
      default: false,
    },
    showIcon: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      displayModal: this.showModal,
      stepCount: 1,
    }
  },

  watch: {
    showModal: {
      immediate: true,
      handler() {
        this.$modal.show('HeatandSteamGuideModal')
      },
    },
    displayModal: {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          this.$modal.show('HeatandSteamGuideModal')
        }
      },
    },
  },

  methods: {
    showInformationGuide() {
      localStorage.setItem('visitedBeforeGuideModal', true)
      this.$modal.show('HeatandSteamGuideModal')
    },

    hideInformationGuide() {
      this.stepCount = 1
      this.displayModal = false
      this.$modal.hide('HeatandSteamGuideModal')
    },
  },
}
</script>
